import React, { useEffect, useState } from 'react';

import './ScenarioVersions.scss';
import { SalvTab, SalvTabList, SalvTabPanel, SalvTabs } from '@salvapp/ui-components';
import {
  InternalApiLibraryScenario,
  InternalApiScenarioVersionBasic,
  InternalApiScenarioVersionStatus,
} from '../../api-internal';
import { useLocation, useSearchParams } from 'react-router-dom';
import ScenarioVersionsTable from './ScenarioVersionsTable';
import LibraryScenarioVersionModal from './version-modal/LibraryScenarioVersionModal';
import dayjs from 'dayjs';

const PARAM_TAB = 'tab';

type LibraryScenarioVersionsProps = {
  libraryScenario: InternalApiLibraryScenario;
};

const LibraryScenarioVersions = ({ libraryScenario }: LibraryScenarioVersionsProps): React.ReactElement | null => {
  const [showVersionModal, setShowVersionModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get(PARAM_TAB) || 'versions';
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const location = useLocation();

  const version: InternalApiScenarioVersionBasic = {
    id: '1',
    versionId: 1,
    status: InternalApiScenarioVersionStatus.DRAFT,
    updatedBy: {
      name: 'Salv',
    },
    updatedTime: dayjs().toDate(),
    parameters: libraryScenario.parameters,
    logic: libraryScenario.logic,
  };

  useEffect(() => {
    searchParams.set(PARAM_TAB, selectedTab);
    setSearchParams(searchParams, {
      state: location.state,
      replace: true,
    });
  }, [selectedTab]);

  const editVersion = () => {
    setShowVersionModal(true);
  };

  return (
    <div className='versions-container'>
      <SalvTabs value={selectedTab} onChange={(value) => setSelectedTab(value)}>
        <SalvTabList>
          <SalvTab value='versions' title={`Versions (1)`} />
        </SalvTabList>
        <SalvTabPanel value='versions'>
          <ScenarioVersionsTable
            versions={[version]}
            entityType={libraryScenario.entityType}
            isLibraryScenario={!!libraryScenario}
            onDeleteVersion={() => {
              // ignore
            }}
            onEditVersion={editVersion}
            onDuplicateAsDraft={() => {
              // ignore
            }}
            onTestVersion={() => {
              // ignore
            }}
          />
        </SalvTabPanel>
      </SalvTabs>

      <LibraryScenarioVersionModal
        showModal={showVersionModal}
        setShowModal={setShowVersionModal}
        scenario={libraryScenario}
      />
    </div>
  );
};

export default LibraryScenarioVersions;
